/* eslint-disable react-hooks/refs */
import type { ComponentProps } from 'react';
import type React from 'react';

import { FloatingArrow, FloatingPortal } from '@floating-ui/react';

import { cn } from '@change/ds-utils';

import { useTooltipContext } from '../hooks/context';

export const TooltipContent: React.FC<ComponentProps<'div'>> = ({ children, className, ...props }) => {
	const context = useTooltipContext();

	if (!context.open) return null;

	return (
		<FloatingPortal>
			<div
				ref={context.refs.setFloating}
				className={cn(
					'border-stroke-info-weak max-w-[400px] min-w-min rounded-md border border-solid bg-black p-4 text-white',
					className,
				)}
				style={context.floatingStyles}
				{...context.getFloatingProps(props)}
				aria-live="polite"
			>
				<FloatingArrow ref={context.arrowRef} context={context.context} fill="var(--color-stroke-info-weak)" />
				{children}
			</div>
		</FloatingPortal>
	);
};
